import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import Plugin
import {
  GlobalConstantsChart,
  GlobalConstantsDom,
  GlobalConstantsTexte,
  GlobalFunctions,
} from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';
import { ErgebnisGebaeude } from 'src/app/data/ws/ergebnis/gebaeude/ergebnis-gebaeude.model';
import { Functions } from 'src/app/functions/functions.module';
import { ConstantsDom } from 'src/app/immutable/constants-dom';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-chart-jaehrliche-gebeude-kosten',
  templateUrl: './chart-jaehrliche-gebeude-kosten.component.html',
  styleUrls: ['./chart-jaehrliche-gebeude-kosten.component.css'],
})
export class ChartJaehrlicheGebeudeKostenComponent implements OnInit {
  @Input() isPro!: boolean;
  private guid: string = Guid.create().toString();
  private ergebnisseSubscription!: Subscription;
  private chartInstance!: Chart;
  private isUpdated = false;

  constructor(public localService: LocalService) {}

  ngOnInit(): void {
    this.ergebnisseSubscription = this.localService.diagramErgebnisse.subscribe(
      (ergebnisse) => {
        if (ergebnisse) {
          this.createChart(ergebnisse.ergebnisGebaeudeList!);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.ergebnisseSubscription) {
      this.ergebnisseSubscription.unsubscribe();
    }
  }

  ngAfterViewChecked(): void {
    if (!this.isUpdated) {
      const element = document.getElementById(ConstantsDom.DOM_CHART_JAEHRLICHE_GEB_KOST);
      if (element) { 
        element.setAttribute(GlobalConstantsDom.DOM_ID, this.guid);
        this.isUpdated = true;
      }
    }
  }
 

  async createChart(ergebnisGebaeudeList: ErgebnisGebaeude[]) {
    await new Promise((f) => setTimeout(f, 1)); // M

    let dataAbschreibungen: number[] = [];
    let dataZinsen: number[] = [];

    let dataUnterhaltung: number[] = [];
    let dataVersicherungen: number[] = [];

    let temp : ErgebnisGebaeude[] = 
    ergebnisGebaeudeList.length > 1 
        ? ergebnisGebaeudeList.slice(1) 
        : ergebnisGebaeudeList.slice(0, 1);

        temp.forEach((entry) => {
      if (this.isPro) {
        dataAbschreibungen.push(
          entry.ergebnisJaehrlicheGebaeudeKosten.abschreibungenJeTp
        );
        dataZinsen.push(entry.ergebnisJaehrlicheGebaeudeKosten.zinsenJeTp);

        dataUnterhaltung.push(
          entry.ergebnisJaehrlicheGebaeudeKosten.unterhaltungJeTp
        );
        dataVersicherungen.push(
          entry.ergebnisJaehrlicheGebaeudeKosten.versicherungenJeTp
        );
      } else {
        dataAbschreibungen.push(
          entry.ergebnisJaehrlicheGebaeudeKosten.abschreibungen
        );
        dataZinsen.push(entry.ergebnisJaehrlicheGebaeudeKosten.zinsen);

        dataUnterhaltung.push(
          entry.ergebnisJaehrlicheGebaeudeKosten.unterhaltung
        );
        dataVersicherungen.push(
          entry.ergebnisJaehrlicheGebaeudeKosten.versicherungen
        );
      }
    });

    let chartDataSets: any[] = [];

    chartDataSets.push({
      label: ConstantsTexte.ABSCHREIBUNGEN,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[0],
      data: dataAbschreibungen,
    });
    chartDataSets.push({
      label: ConstantsTexte.ZINSKOSTEN,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[1],
      data: dataZinsen,
    });
    chartDataSets.push({
      label: ConstantsTexte.UNTERHALTUNG,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[2],
      data: dataUnterhaltung,
    });
    chartDataSets.push({
      label: ConstantsTexte.VERSICHERUNGEN,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[3],
      data: dataVersicherungen,
    });

    let titleText: string = ConstantsTexte.JAEHRLICHE_GEBAEUDEKOSTEN;
    let seitenUeberschriftText: string = GlobalConstantsTexte.IN_EURO_A;
    let nachkommastellen: number = 0;

    if (this.isPro) { 

      if (this.localService.istGebaeude.value) {
        if ((temp[0].gebaeude.flaechenVolumen.find(fv => fv.istKostenrelevant)?.dimension) === GlobalConstantsTexte.EINHEIT_M3) {
          titleText += ' ' + GlobalConstantsTexte.JE_M3;
        } else {
          titleText += ' ' + GlobalConstantsTexte.JE_M2;
        }
      } else {
        titleText += ' ' + GlobalConstantsTexte.JE_TIERPLATZ;
        seitenUeberschriftText = titleText + ' ' + seitenUeberschriftText;
      }

      nachkommastellen = 2;
    }
    else{
      seitenUeberschriftText = titleText + ' ' + seitenUeberschriftText;
    }

    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    Chart.register(ChartDataLabels); // Register Plugin

    this.chartInstance = GlobalFunctions.getDiagramm(
      this.guid,
      Functions.getChartLabels(
        temp,
        this.localService.istGebaeude.value
      ),
      chartDataSets,
      titleText,
      seitenUeberschriftText,
      nachkommastellen,
      true,
      GlobalConstantsChart.FARBE_WEISS
    );
  }
}
